export const modalConstants = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning',
  CLEAR: 'clear'
};
